const formatPhone = phone =>
  `(${phone.substring(0, 3)}) ${phone.substring(3, 6)}-${phone.substring(6)}`;

export const mapPhoneButton = (fields, values, buttonName, propName) => {
  const button = fields.find(field => field.name === buttonName);
  if (button) {
    if (values[propName]) {
      const formatedPhone = formatPhone(values[propName]);
      button.params = button.params.replace("TDFieldOptionIgnore", "");
      button.title = formatedPhone;
      button.action.value = formatedPhone;
    } else {
      button.params += "|TDFieldOptionIgnore";
    }
  }
};
